export enum EDemandDisplayMode {
  BANNER,
  CARD,
}
